export default "__VITE_ASSET__1563d2f8__"